export default __webpack_public_path__ + "static/jeans-ef18b34c2101e6b7a5b5f56fe20c6a5a.png";